import { AccordionSummary, withStyles } from '@material-ui/core';

export default withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .10)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(AccordionSummary);
